export default __webpack_public_path__ + "static/media/port5.1330f6cd.jpg";